<template>
  <Dialog v-model:visible="show" modal @hide="onHide" @show="onShow">
    <template #header>
      <i class="pi pi-sitemap mr-3" style="font-size: 2rem; color: rgb(204,204,0)" />
      <div class="col-10 font-bold text-center" style="font-size: 1.3rem">
        Диагностика
        <Tag :value="serverName" class="user-role-tag mr-1" severity="success" :title="serverNameRu" />
      </div>
    </template>
    <div class="formgrid grid vertical-container mt-4" v-for="service in services" :key="service.name">
      <div class="font-bold col-1">
        <i :class="[getIconClass(service.status), 'icon']" @click="copyToClipboard(service.text)"></i>
      </div>
      <div class="col-1-5"> <span v-if="service.duration">{{ service.duration }} ms</span></div>
      <span class="font-bold col-2-5">{{ service.name }}</span>
      <a class="font-italic col-7" target="_blank" :href="$store.getters.server(service.store) + service.path">{{
        $store.getters.server(service.store) + service.path }}</a>
    </div>
    <Fieldset legend="Метрики браузера" toggleable collapsed class="mt-4 perf-fieldset"
      style="max-width: 600px; margin: 0 auto;">
      <div class="px-3">
        <div class="grid formgrid">
          <div class="col-12">
            <div class="flex justify-content-between mb-2 text-sm">
              <span class="text-color-secondary font-bold">Общая загрузка</span>
              <Tag :value="perf.nav.duration + ' ms'"
                :severity="perf.nav.duration > 3000 ? 'danger' : perf.nav.duration > 1500 ? 'warning' : 'success'" />
            </div>
            <div class="grid formgrid text-sm">
              <div class="col-4">
                <div class="flex justify-content-between">
                  <span class="text-color-secondary" v-tooltip="'Время разрешения доменного имени'">DNS</span>
                  <span class="font-bold">{{ perf.nav.dns }} ms</span>
                </div>
              </div>
              <div class="col-4">
                <div class="flex justify-content-between">
                  <span class="text-color-secondary" v-tooltip="'Время установления TCP-соединения'">TCP</span>
                  <span class="font-bold">{{ perf.nav.tcp }} ms</span>
                </div>
              </div>
              <div class="col-4">
                <div class="flex justify-content-between">
                  <span class="text-color-secondary" v-tooltip="'Время SSL-рукопожатия'">SSL</span>
                  <span class="font-bold">{{ perf.nav.ssl }} ms</span>
                </div>
              </div>
              <div class="col-4">
                <div class="flex justify-content-between">
                  <span class="text-color-secondary"
                    v-tooltip="'Time To First Byte — время до получения первого байта от сервера'">TTFB</span>
                  <Tag :value="perf.nav.ttfb + ' ms'"
                    :severity="perf.nav.ttfb > 600 ? 'danger' : perf.nav.ttfb > 200 ? 'warning' : 'success'"
                    size="small" />
                </div>
              </div>
              <div class="col-4">
                <div class="flex justify-content-between">
                  <span class="text-color-secondary" v-tooltip="'Время парсинга и построения DOM-дерева'">DOM</span>
                  <span class="font-bold">{{ perf.nav.domProcessing }} ms</span>
                </div>
              </div>
              <div class="col-4">
                <div class="flex justify-content-between">
                  <span class="text-color-secondary"
                    v-tooltip="'Полная загрузка страницы (включая все ресурсы и load event)'">Full load</span>
                  <span class="font-bold">{{ perf.nav.fullLoad }} ms</span>
                </div>
              </div>
            </div>
          </div>

          <Divider />

          <div class="col-12">
            <div class="grid formgrid text-sm">
              <div class="col-4">
                <div class="flex justify-content-between mb-1">
                  <span class="text-color-secondary">Всего ресурсов</span>
                  <span class="font-bold">{{ perf.resources.total }} шт.</span>
                </div>
              </div>
              <div class="col-4">
                <div class="flex justify-content-between mb-1">
                  <span class="text-color-secondary" v-tooltip="'Ресурсы с загрузкой более 500 мс'">Медленные
                  </span>
                  <Tag :value="perf.resources.slow === 0 ? '-' : perf.resources.slow"
                    :severity="perf.resources.slow > 0 ? 'danger' : 'success'" size="small"
                    v-tooltip="perf.resources.slowNames.length ? perf.resources.slowNames.join('\n') : null" />
                </div>
              </div>
              <div class="col-4">
                <div class="flex justify-content-between mb-1">
                  <span class="text-color-secondary" v-tooltip="'Ресурсы размером более 100 КБ'">Крупные</span>
                  <Tag :value="perf.resources.large === 0 ? '-' : perf.resources.large"
                    :severity="perf.resources.large > 2 ? 'danger' : perf.resources.large > 0 ? 'warning' : 'success'"
                    size="small"
                    v-tooltip="perf.resources.largeNames.length ? perf.resources.largeNames.join('\n') : null" />
                </div>
              </div>
              <div class="col-4">
                <div class="flex justify-content-between mb-1">
                  <span class="text-color-secondary"
                    v-tooltip="'Скорость передачи данных (без учёта кэша и обработки на сервере)'">Скорость</span>
                  <Tag :value="perf.resources.speed > 0 ? perf.resources.speed + ' КБ/с' : '-'"
                    :severity="perf.resources.speed > 500 ? 'success' : perf.resources.speed > 300 ? 'warning' : perf.resources.speed > 0 ? 'danger' : null"
                    size="small" />
                </div>
              </div>
              <div class="col-12">
                <span class="text-xs text-color-secondary">По типам:</span>
                <div class="flex flex-wrap gap-2 mt-1">
                  <Tag v-for="(count, type) in perf.resources.byType" :key="type" :value="`${type}: ${count}`"
                    severity="info" size="small" />
                </div>
              </div>
            </div>
          </div>

          <Divider />

          <div class="col-12">
            <div class="grid formgrid text-sm">
              <div class="col-4">
                <div class="text-color-secondary font-bold mb-1">Сеть</div>
                <div class="flex justify-content-between mb-1">
                  <span class="text-color-secondary">Тип</span>
                  <Tag :value="perf.network.effectiveType"
                    :severity="perf.network.effectiveType === '4g' ? 'success' : perf.network.effectiveType === '3g' ? 'warning' : 'danger'"
                    size="small" />
                </div>
                <div class="flex justify-content-between mb-1">
                  <span class="text-color-secondary" v-tooltip="'Оценочная пропускная способность сети'">Downlink</span>
                  <span class="font-bold">{{ perf.network.downlink }} Mbps</span>
                </div>
                <div class="flex justify-content-between mb-1">
                  <span class="text-color-secondary" v-tooltip="'Время ROUND-TRIP до сервера'">RTT</span>
                  <span class="font-bold">{{ perf.network.rtt }} ms</span>
                </div>
                <div class="flex justify-content-between mb-1">
                  <span class="text-color-secondary" v-tooltip="'Экономия трафика браузерером'">Data Saver</span>
                  <span class="font-bold">{{ perf.network.saveData ? 'On' : 'Off' }}</span>
                </div>
                <div class="flex justify-content-between">
                  <span class="text-color-secondary">Online</span>
                  <Tag :value="perf.network.online ? 'Yes' : 'No'"
                    :severity="perf.network.online ? 'success' : 'danger'" size="small" />
                </div>
              </div>
              <div class="col-4">
                <div class="text-color-secondary font-bold mb-1">Устройство</div>
                <div class="flex justify-content-between mb-1">
                  <span class="text-color-secondary">CPU</span>
                  <span class="font-bold">{{ perf.device.cores }} cores</span>
                </div>
                <div class="flex justify-content-between mb-1">
                  <span class="text-color-secondary">RAM</span>
                  <span class="font-bold">{{ perf.device.memory }} GB</span>
                </div>
              </div>
              <div class="col-4">
                <div class="text-color-secondary font-bold mb-1">Память JS</div>
                <div class="flex justify-content-between mb-1">
                  <span class="text-color-secondary">Used</span>
                  <span class="font-bold">{{ perf.memory.used }} MB</span>
                </div>
                <div class="flex justify-content-between mb-1">
                  <span class="text-color-secondary">Total</span>
                  <span class="font-bold">{{ perf.memory.total }} MB</span>
                </div>
                <div class="flex justify-content-between mb-1">
                  <span class="text-color-secondary">Limit</span>
                  <span class="font-bold">{{ perf.memory.limit }} MB</span>
                </div>
                <ProgressBar :value="perf.memory.percent" :show-value="false" style="height: 6px" />
                <div class="text-xs text-color-secondary mt-1">{{ perf.memory.percent }}% used</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fieldset>

    <div class="text-center mt-4">
      <Button icon="pi pi-refresh" @click="resetServices(); onShow();" label="Обновить" />
    </div>
    <template #footer>
      <Button label="Ok" icon="pi pi-check" class="p-button-text" @click="show = false" />
    </template>
  </Dialog>
</template>

<script setup>

import { ref, computed, onUnmounted, defineProps, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'primevue/usetoast';
import axios from 'axios';
import Fieldset from 'primevue/fieldset';
import Divider from 'primevue/divider';
import ProgressBar from 'primevue/progressbar';
import Tag from 'primevue/tag';
import Button from 'primevue/button';

const store = useStore();
const toast = useToast();

const STATUSES = {
  ok: 'ok',
  load: 'load',
  warn: 'warn',
  er: 'er'
}

const props = defineProps({
  showDiagnostic: Boolean
})
const emit = defineEmits(['update:showDiagnostic']);

const abortController = ref(null);
const serverNameRu = store.getters.const(process.env.VUE_APP_SERVER_NAME);
const serverName = process.env.VUE_APP_SERVER_NAME;
const services = ref([
  { request: 'get', name: 'Backend(rest api)', store: 'SERVER', path: '' },
  { request: 'get', name: 'Stimulsoft', store: 'ADAPTER', path: 'status' },
  { request: 'options', name: 'WildFly', store: 'TM_MIDDLE', path: 'kron.tm3.service-web-1.0/webresources/restservice/state' }
]);

const perf = ref({
  nav: { duration: 0, dns: 0, tcp: 0, ssl: 0, ttfb: 0, domProcessing: 0, fullLoad: 0 },
  resources: { total: 0, slow: 0, large: 0, byType: {}, slowNames: [], largeNames: [], speed: 0 },
  network: { effectiveType: '-', downlink: 0, rtt: 0, saveData: false, online: true },
  device: { cores: 0, memory: 0 },
  memory: { used: 0, total: 0, percent: 0 }
});

const collectPerformanceMetrics = () => {
  try {
    const navEntries = performance.getEntriesByType('navigation');
    if (navEntries.length > 0) {
      const nav = navEntries[0];
      perf.value.nav = {
        duration: Math.round(nav.duration),
        dns: Math.round(nav.domainLookupEnd - nav.domainLookupStart),
        tcp: Math.round(nav.connectEnd - nav.connectStart),
        ssl: Math.round(nav.secureConnectionEnd - nav.connectStart),
        ttfb: Math.round(nav.responseStart),
        domProcessing: Math.round(nav.domContentLoadedEventEnd - nav.domInteractive),
        fullLoad: Math.round(nav.loadEventEnd)
      };
    }
  } catch (e) {
    console.warn('Navigation timing not available', e);
  }

  try {
    const resources = performance.getEntriesByType('resource');
    const byType = {};

    const slowNames = [];
    const largeNames = [];
    let speed = 0;
    const nonCached = resources.filter(r => r.deliveryType !== 'cache' && r.transferSize > 900);
    const candidates = nonCached.filter(r =>
      r.initiatorType === 'script' || r.initiatorType === 'xmlhttprequest'
    );
    if (candidates.length > 0) {
      let totalTransferSize = 0;
      let totalTransferDuration = 0;

      candidates.forEach(r => {
        totalTransferSize += r.transferSize;
        const transferDuration = r.requestStart
          ? (r.responseEnd - r.requestStart) / 1000
          : r.duration / 1000;

        totalTransferDuration += transferDuration;
      });

      if (totalTransferDuration > 0) {
        speed = Math.round((totalTransferSize / 1024) / totalTransferDuration);
      }
    }

    const isImage = (r) => {
      const type = r.initiatorType || '';
      if (type === 'img' || type === 'link' || type === 'other') {
        // const name = r.name.toLowerCase();
        // return /\.(png|jpe?g|gif|svg|webp|avif|ico|bmp)(\?|$)/.test(name);
        return true;
      }
      return false;
    };

    resources.forEach(r => {
      const type = r.initiatorType || 'other';
      byType[type] = (byType[type] || 0) + 1;

      const name = r.name || '';
      if (r.duration > 500 && !isImage(r)) {
        slowNames.push(name);
      }
      if (r.transferSize > 100 * 1024 && !isImage(r)) {
        largeNames.push(name);
      }
    });

    perf.value.resources = {
      total: resources.length,
      slow: slowNames.length,
      large: largeNames.length,
      byType,
      slowNames,
      largeNames,
      speed
    };
  } catch (e) {
    console.warn('Resource timing not available', e);
  }

  try {
    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn) {
      perf.value.network = {
        effectiveType: conn.effectiveType || '-',
        downlink: conn.downlink || 0,
        rtt: conn.rtt || 0,
        saveData: conn.saveData || false,
        online: navigator.onLine
      };
    } else {
      perf.value.network.online = navigator.onLine;
    }
  } catch (e) {
    perf.value.network.online = navigator.onLine;
  }

  perf.value.device.cores = navigator.hardwareConcurrency || 0;
  perf.value.device.memory = navigator.deviceMemory || 0;

  try {
    const mem = performance.memory;
    if (mem) {
      perf.value.memory = {
        used: Math.round(mem.usedJSHeapSize / 1024 / 1024),
        total: Math.round(mem.totalJSHeapSize / 1024 / 1024),
        percent: Math.round((mem.usedJSHeapSize / mem.jsHeapSizeLimit) * 100),
        limit: Math.round(mem.jsHeapSizeLimit / 1024 / 1024),
      };
    }
  } catch (e) {
    console.warn('memory API not available', e);
  }
};

const show = computed({
  get: () => props.showDiagnostic,
  set: (val) => emit('update:showDiagnostic', val)
});

const onHide = () => {
  resetServices();
}

const copyToClipboard = async (text) => {
  if (!text) return;

  if (typeof text === 'object') {
    text = JSON.stringify(text);
  }

  try {
    await navigator.clipboard.writeText(text);
    toast.add({
      severity: 'success',
      summary: 'Текст скопирован',
      detail: 'Ответ сервиса скопирован в буфер обмена',
      life: 3000
    });
  } catch (err) {
    fallbackCopyText(text);
  }
}

const fallbackCopyText = (text) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.opacity = 0;
  document.body.appendChild(textArea);
  textArea.select();

  try {
    document.execCommand('copy');
    toast.add({
      severity: 'success',
      summary: 'Текст скопирован',
      detail: 'Данные успешно скопированы в буфер обмена',
      life: 3000
    });
  } catch (err) {
    console.error('Fallback copy failed: ', err);
  }

  document.body.removeChild(textArea);
}

const onShow = () => {
  abortController.value = new AbortController();
  const signal = abortController.value.signal;

  for (let i = 0; i < services.value.length; i++) {
    services.value[i].status = STATUSES.load;
    services.value[i].timer = performance.now();
    axios[services.value[i].request](store.getters.server(services.value[i].store) + services.value[i].path, {
      signal: signal,
      timeout: 5000,
      validateStatus: () => true
    })
      .then((res) => {
        services.value[i].text = res;
        services.value[i].status = STATUSES.ok;
        const duration = Math.round(performance.now() - services.value[i].timer);
        services.value[i].duration = duration;
      })
      .catch((er) => {
        const duration = Math.round(performance.now() - services.value[i].timer);
        if (duration < 2000) {
          services.value[i].status = STATUSES.warn;
        } else {
          services.value[i].status = STATUSES.er;
        }
        services.value[i].duration = duration;
        services.value[i].text = er;
      })
  }

  collectPerformanceMetrics();
}

const getIconClass = (status) => {
  switch (status) {
    case STATUSES.ok:
      return 'pi pi-check-circle icon-ok';
    case STATUSES.load:
      return 'pi pi-spin pi-spinner icon-load';
    case STATUSES.warn:
      return 'pi pi-minus-circle icon-warn';
    case STATUSES.er:
      return 'pi pi-ban icon-er';
    default:
      return 'pi pi-circle';
  }
}

const resetServices = () => {
  if (abortController.value) {
    abortController.value.abort();
    abortController.value = null;
  }
  for (let i = 0; i < services.value.length; i++) {
    services.value[i] = {
      ...services.value[i],
      status: null,
      timer: null,
      text: null,
      duration: null
    }
  }
}

onUnmounted(() => {
  if (abortController.value) {
    abortController.value.abort();
  }
})
</script>

<style lang="scss" scoped>
.icon {
  transition: all 0.2s ease;
  font-size: 1.2rem;

  &:hover {
    transform: scale(1.1);
  }
}

.pi-spin {
  animation-duration: 1.5s;
}

.icon-ok {
  color: green;
  cursor: pointer;
}

.icon-warn {
  color: orange;
  cursor: pointer;
}

.icon-load {
  color: blue;
  cursor: pointer;
}

.icon-er {
  color: red;
  cursor: pointer;
}

:deep(.p-tooltip-text) {
  white-space: pre-line;
}

.justify-content-between {
  align-items: center;
}

.p-tag {
  padding: 0.1rem 0.4rem;
}

.perf-fieldset {
  :deep(.p-fieldset-legend a) {
    padding: 0.8rem !important;
  }
}
</style>

<style lang="scss"></style>